require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-c-3-nhet-66-th-3-x-123-k-p-dfetlu.json") })
        }
      }, "path---news-c-3-nhet-66-th-3-x-123-k-p-dfetlu");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-c-3-nhet-66-th-3-x-123-k-p-dfetlu!./.cache/json/news-c-3-nhet-66-th-3-x-123-k-p-dfetlu.json
// module id = ./node_modules/gatsby-module-loader/index.js?name=path---news-c-3-nhet-66-th-3-x-123-k-p-dfetlu!./.cache/json/news-c-3-nhet-66-th-3-x-123-k-p-dfetlu.json
// module chunks = 231608221292675